module.exports = __webpack_public_path__ + "./fonts/telefono-QR.d0e1ae085998fbf8019c1e296baf36b5.svg";


//////////////////
// WEBPACK FOOTER
// ./public/img/telefono-QR.svg
// module id = ./public/img/telefono-QR.svg
// module chunks = 0